// 订单列表搜索
const OrderListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'order.orderName', // 订单名称
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderName',
        },
        {
            // name:'order.frameNumber', // 车架号   
            key:'frame_number',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.frameNumber',
        },
        {
            // name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderSource',
            // optionToLocale:true,
            options:[]
        },
        {
            // name:'order.orderStatus', // 订单状态
            key:'order_status',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderStatus',
            optionToLocale:true,
            options:[
                {
                    value:7,
                    label:'order.obligation'
                },
                {
                    value:0,
                    label:'order.partialPay'
                },
                {
                    value:1,
                    label:'order.pay'
                },
                {
                    value:2,
                    label:'order.refund'
                },
                // {
                //     value:3,
                //     label:'order.returnsAndRefund'
                // },
                {
                    value:4,
                    label:'order.partialRefund'
                },
                // {
                //     value:5,
                //     label:'order.partialReturnsAndRefund'
                // },
                // {
                //     value:-1,
                //     label:'order.finalPayment'
                // },
                {
                    value:6,
                    label:'order.canceled'
                },
            ]
        },
        {
            // name:'order.deliverStatus', // 发货状态
            key:'courier_status',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.deliverStatus',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.unship',
                    disabled:false
                },
                {
                    value:1,
                    label:'order.plan',
                    disabled:false
                },
                {
                    value:2,
                    label:'order.partialShip',
                    disabled:false
                },
                {
                    value:3,
                    label:'order.shiped',
                    disabled:false
                },
                {
                    value:4,
                    label:'order.signedFor',
                    disabled:false
                },
                {
                    value:5,
                    label:'order.canceled',
                    disabled:false
                },
                {
                    value:7,
                    label:'order.partialReturn',
                    disabled:false
                },
                {
                    value:8,
                    label:'order.return',
                    disabled:false
                },
                {
                    value:10,
                    label:'order.partialExchange',
                    disabled:false
                },
                {
                    value:9,
                    label:'order.exchange',
                    disabled:false
                },
                {
                    value:99,
                    label:'order.noNeedToShip',
                    disabled:false
                },
            ]
        },
        {
            // name:'order.customerName', // SKU
            key:'sku',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.sku',
            options:[]
        },
        {
            // name:'order.customerName', // SO
            key:'erp_no',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.erpNo',
        },
        {
            // name:'order.customerName', // 客户名称
            key:'customer_entity_id',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.customerName',
            options:[]
        },
        {
            // name:'order.customerName', // 客户地址名称
            key:'customer_id',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'customer.contactName3',
            options:[]
        },
        {
            // name:'order.customerType', // 订单类型
            key:'order_channel_type',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderChannelType',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                // {
                //     value:2,
                //     label:'order.ECommerceVendor',
                // },
                {
                    value:3,
                    label:'order.notForSale'
                },
                {
                    value:4,
                    label:'order.service'
                },
                {
                    value:-1,
                    label:'order.virtual'
                },
                {
                    value:5,
                    label:'order.c2c'
                },
            ]
        },
        {
            // name:'order.country', // 国家
            key:'country',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.country',
            options:[]
        },
        {
            // name:'order.customerType', // 邮箱
            key:'customer_email',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'customer.customerEmail',
        },
        {
            // name:'order.createUser', // 订单类型
            key:'order_type',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderType',
            optionToLocale:true,
            options:[
                {
                    label:'order.sale',
                    value:0,
                },
                {
                    label:'order.unSale',
                    value:1
                }
            ]
        },
        {
            // name:'order.createUser', // 创建人
            key:'create_by',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.createUser',
            options:[]
        },
        // {
        //     // name:'order.customerType', // 发票号
        //     key:'invoice_no',
        //     type:'input',   
        //     allowClear:true,
        //     width:'230px',
        //     placeholder:'order.invoiceNo',
        // },
        {
            // name:'order.customerType', // 备注
            key:'instruction',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.instruction',
        },
        {
            // name:'order.createUser', // 风险等级
            key:'risk_level',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.riskLevel',
            optionToLocale:true,
            options:[
                {
                    label:'order.highRisk',
                    value:3,
                },
                {
                    label:'order.mediumRisk',
                    value:2,
                },
                {
                    label:'order.lowRisk',
                    value:1,
                },
                {
                    label:'order.none',
                    value:0,
                },
            ]
        },
        {
            key:'second_hand_flag',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.secondHandFlag',
            optionToLocale:true,
            options:[
                {
                    label:'base.YES',
                    value:1
                },
                {
                    label:'base.NO',
                    value:0
                }
            ]
        },
        {
            key:'order_category',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderCategory',
            optionToLocale:true,
            options:[
                {
                    label:'dealerOpenOrder.bike',
                    value:1
                },
                {
                    label:'dealerOpenOrder.parts',
                    value:2
                },
                                {
                    label:'dealerOpenOrder.normal',
                    value:0
                }
            ]
        },
        {
            // name:'order.orderDate', // 订单时间
            key:'order_date',
            type:'dateRange',   
            allowClear:true,
            // valueFormat:'timestamp',
            width:'230px',
        },
    ]
}

// 发货申请
const DeliverForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    formData:{},
    formField:[
        // {
        //     name:'order.wms',// 发货仓库
        //     key:'warehouse',
        //     type:'select',
        //     required: true,
        //     width:'450px',
        //     placeholder:'base.select',
        //     options:[]
        // },
        // {
        //     name:'order.rollOverInventory',// 转仓仓库
        //     key:'roll_over_inventory',
        //     type:'select',
        //     required: true,
        //     show:false,
        //     width:'450px',
        //     placeholder:'base.select',
        //     options:[]
        // },
        {
            name:'order.courierType',// 物流公司
            key:'courier_type',
            type:'select',
            allowClear:true,
            required: false,
            width:'450px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'order.courierNo',//物流单号
            key:'courier_no',
            type:'input',   
            allowClear:true,
            required: false,
            disabled:false,
            width:'450px',
            placeholder:'base.input',
        },
        {
            name:'order.courierLink',//物流链接
            key:'courier_url',
            type:'input',   
            allowClear:true,
            required: false,
            disabled:false,
            width:'450px',
            placeholder:'base.input',
        },
        // {
        //     name:'order.handleTimestamp',//预计发货时间
        //     key:'transaction_date',
        //     type:'date',
        //     required: false,
        //     width:'450px',
        //     disabledDate:true,
        //     showItemAfterText:true,
        // },
    ]
}

// 创建订单-基础信息
const CreateOrderForm1 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'190px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.orderType', // 订单销售类型
            key:'order_type',
            type:'select',   
            allowClear:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'order.sale',
                    value:0,
                },
                {
                    label:'order.unSale',
                    value:1
                }
            ]
        },
        {
            name:'order.orderUse', // 订单用途
            key:'order_use',
            type:'select',
            required:true,
            // disabled:true,
            show:false,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[]
        },
        {
            name:'order.backFlag', // 是否退回
            key:'back_flag',
            type:'select', 
            required:true,
            // disabled:true,
            show:false,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'order.isReturn',
                    value:'YES',
                },
                {
                    label:'order.notReturn',
                    value:'NO',
                }
            ]
        },
        {
            name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            required:true,
            questionIcon:true,
            width:'420px',
            tips:'Order channels from online or offline channel',
            placeholder:'base.select',
            optionToLocale:true,
            options:[]
        },
        {
            name:'order.orderChannelType', // 订单渠道类型
            key:'order_channel_type',
            type:'select',   
            allowClear:true,
            required:true,
            disabled:true,
            // questionIcon:true,
            width:'420px',
            // tips:'Order channels from online or offline channel',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:2,
                    label:'order.ECommerceVendor',
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
                {
                    value:4,
                    label:'order.service'
                },
                {
                    value:-1,
                    label:'order.virtual'
                },
                {
                    value:5,
                    label:'order.c2c'
                },
            ]
        },
        {
            name:'order.orderName', // 订单名称
            key:'order_name',
            type:'input',   
            allowClear:true,
            required:true,
            questionIcon:true,
            showItemPreText:false,
            width:'420px',
            tips:'Order No. can be defined from first channel 3 characters. like AMZxxx',
            placeholder:'base.input',
        },
        {
            name:'order.orderStatus', // 订单状态
            key:'order_status',
            type:'select',   
            allowClear:true,
            required:true,
            width:'420px',
            marginLeft:'-30px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    value:7,
                    label:'order.obligation',
                    disabled:false,
                },
                {
                    value:0,
                    label:'order.partialPay',
                    disabled:false,
                },
                {
                    value:1,
                    label:'order.pay',
                    disabled:false,
                },
                {
                    value:6,
                    label:'order.canceled',
                    disabled:false,
                },
                {
                    value:2,
                    label:'order.refund',
                    disabled:true,
                },
                // {
                //     value:3,
                //     label:'order.returnsAndRefund',
                //     disabled:true,
                // },
                {
                    value:4,
                    label:'order.partialRefund',
                    disabled:true,
                },
                // {
                //     value:5,
                //     label:'order.partialReturnsAndRefund',
                //     disabled:true,
                // },
                // {
                //     value:-1,
                //     label:'order.finalPayment',
                //     disabled:true,
                // },
                
            ]
        },
        {
            name:'order.orderCategory', // 订单类别  整车/零配件
            key:'order_category',
            type:'select',   
            allowClear:true,
            required:false,
            disabled:true,
            show:false,
            width:'420px',
            showItemPreText:false,
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.normal'
                },
                {
                    value:1,
                    label:'order.bike'
                },
                {
                    value:2,
                    label:'order.part'
                },
            ]   
        },
        {
            name:'order.deliverStatus', // 发货状态
            key:'courier_status',
            type:'select',   
            allowClear:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.unship',
                    disabled:false,
                },
                {
                    value:5,
                    label:'order.canceled',
                    disabled:false,
                },
                {
                    value:1,
                    label:'order.plan',
                    disabled:true,
                },
                {
                    value:2,
                    label:'order.partialShip',
                    disabled:true,
                },
                {
                    value:3,
                    label:'order.shiped',
                    disabled:true,
                },
                {
                    value:4,
                    label:'order.signedFor',
                    disabled:true,
                },
                {
                    value:8,
                    label:'order.return',
                    disabled:true,
                },
                {
                    value:9,
                    label:'order.exchange',
                    disabled:true,
                },
                {
                    value:99,
                    label:'order.noNeedToShip',
                    disabled:false
                },
            ]
        },
        {
            name:'order.secondHandFlag', // 是否二手车
            key:'second_hand_flag',
            type:'select', 
            disabled:false,
            required:true,
            placeholder:'base.select',
            optionToLocale:true,
            width:'420px',
            options:[
                {
                    label:'base.YES',
                    value:1
                },
                {
                    label:'base.NO',
                    value:0
                }
            ],
        },
        {
            name:'order.deliveryType', // 发货方式
            key:'delivery_type',
            type:'select', 
            disabled:true,
            placeholder:'base.select',
            optionToLocale:true,
            width:'420px',
            options:[],
        },
        {
            name:'order.deliveryTimeliness', // 物流时效
            key:'delivery_timeliness',
            type:'select',
            disabled:false,
            show:false,
            placeholder:'base.select',
            optionToLocale:true,
            width:'420px',
            options:[
                {
                    label:'order.standard',
                    value:0,
                    disabled:false,
                },
                {
                    label:'order.express',
                    value:1,
                    disabled:false,
                }
            ],
        },
        {
            name:'order.orderTimestamp', // 下单时间
            key:'order_timestamp',
            type:'date',   
            allowClear:true,
            required:true,
            disabledDate:false,
            format:'YYYY-MM-DD hh:mm:ss',
            width:'420px',
            marginLeft:'-30px',
        },
        {
            name:'order.shipYear', // 预计发货年份
            key:'predict_delivery_year',
            type:'yearDate',   
            allowClear:true,
            required:false,
            width:'420px',
        },
        {
            name:'order.shipWeek', // 预计发货周别
            key:'predict_week_date',
            type:'weekDate',   
            allowClear:true,
            required:false,
            width:'420px',
        },
        {
            name:'order.earliestShipTimestamp', // 最早发货时间
            key:'earliest_ship_timestamp',
            type:'date',   
            allowClear:true,
            showItemAfterText:true,
            format:'YYYY-MM-DD hh:mm:ss',
            width:'420px',
            marginLeft:'-30px',
        },
        {
            name:'order.taxRate', // 扣税税率
            key:'tax_rate',
            type:'select',
            questionIcon:true,
            required:true,
            width:'420px',
            tips:'Select from differently',
            options:[]
        },
        {
            name:'order.preAfterTax', // 税前税后方式
            key:'tax_type',
            type:'select',
            // allowClear:true,
            required:false,
            disabled:true,
            width:'420px',
            optionToLocale:true,
            options:[
                {
                    label:'order.preTax', // 不含税
                    value:1,
                },
                {
                    label:'order.afterTax', // 含税
                    value:0,
                }
            ]
        },
        {
            name:'order.paymentType', // 支付方式
            key:'payment_type',
            type:'select',
            allowClear:false,
            required:false,
            questionIcon:true,
            disabled:true,
            showItemPreText:false,
            width:'420px',
            marginLeft:'-30px',
            placeholder:'base.select',
            options:[],
            tips:'1. SEPA - 2% discount on orders; 2. by invoice - Customers transfer their own funds with a 1% discount for payments made within 14 days; 3. SEPA(no cash discount) - SEPA discount of 0%; 4. Advance payment - no discount',
        },
        {
            name:'preSaleOrder.winterFinancing', // 是否冬季折扣
            key:'winter_flag', 
            type:'select',
            disabled:true,
            required:true,
            show:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label: 'base.yes', 
                    value:1
                }, 
                {
                    label: 'base.no', 
                    value:0
                }
            ]
        },
        {
            name:'order.paymentTypeDiscount', // 支付折扣比例
            key:'payment_type_discount',
            type:'select',
            disabled:true,
            width:'420px',
            optionToLocale:true,
            options:[],
        },
        {
            name:'order.payTypeDiscount', // 支付折扣
            key:'pay_type_discount',
            type:'input',   
            // allowClear:true,
            disabled:true,
            // required:true,
            editAmount:true,
            prefix:true,
            width:'420px',
        },
        {
            name:'order.payWithDaysDiscountRate', // 现金折扣比例
            key:'pay_with_days_discount_rate',
            type:'select',
            disabled:true,
            width:'420px',
            optionToLocale:true,
            options:[],
        },
        {
            name:'order.cashDiscountRatioDay', // 现金折扣比例计算天数
            key:'pay_with_days_day',
            type:'select',
            required:true,
            disabled:true,
            width:'420px',
            optionToLocale:true,
            options:[],
        },
        {
            name:'order.payDay', // 账期
            key:'payment_day',
            type:'select',
            disabled:true,
            show:true,
            width:'420px',
            optionToLocale:true,
            options:[],
        },
        {
            name:'preSaleOrder.paymentPeriod',
            key:'payment_due_date', 
            type:'date',
            disabled:true,
            required:false,
            show:true,
            width:'420px',
            placeholder:'base.select',
            showTime:false, 
            show:false,
        },
        // {
        //     name:'order.payTypeDiscount2', // 支付折扣2
        //     key:'pay_type_discount2',
        //     type:'input',   
        //     // allowClear:true,
        //     disabled:true,
        //     // required:true,
        //     editAmount:false,
        //     prefix:true,
        //     width:'420px',
        // },
        {
            name:'order.cargoFreight2', // 运费
            key:'cargo_freight',
            type:'input',   
            // allowClear:true,
            required:true,
            prefix:true,
            showItemPreText:true,
            width:'420px',
        },
        {
            name:'order.instruction', // 备注
            key:'instruction',
            type:'textarea',   
            allowClear:true,
            showWordLimit:true,
            maxLength:150,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'order.userNote', // 用户备注-仅限业务订单生成订单有该字段
            key:'user_note',
            type:'textarea',   
            disabled:true,
            width:'420px',
            show:false,
            placeholder:'base.input',
        },
    ]
}

// 创建订单-金额汇总信息
const CreateOrderForm2 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'190px',
    showSlot:true,
    formData:{},
    formField:[
        // {
        //     name:'order.orderAmount', // 订单金额
        //     key:'order_amount',
        //     type:'inputNumber',
        //     disabled:true,
        //     prefix:true,
        //     hideButton:true,
        //     questionIcon:true,
        //     min:0,
        //     width:'420px',
        //     tips:'The sum of the amounts for each order line',
        // },
        {
            name:'order.orderAmount', // 订单金额
            key:'order_amount',
            type:'input',
            disabled:true,
            prefix:true,
            questionIcon:true,
            width:'420px',
            tips:'The sum of the amounts for each order line',
        },
        {
            name:'order.c2cExtraAmount', // C&C订单金额
            key:'c2c_extra_amount',
            type:'input',
            disabled:true,
            prefix:true,
            questionIcon:false,
            width:'420px',
            // tips:'The sum of the amounts for each order line',
        },
        {
            name:'order.quantity', // 数量
            key:'quantity',
            type:'inputNumber',
            disabled:true,
            hideButton:true,
            questionIcon:true,
            min:0,
            width:'420px',
            tips:'Sum of order line quantities.',
        },
        // {
        //     name:'order.orderDiscount', // 订单折扣
        //     key:'order_discount',
        //     type:'inputNumber', 
        //     disabled:true,
        //     prefix:true,
        //     hideButton:true,
        //     questionIcon:true,
        //     min:0,
        //     width:'420px',
        //     tips:'The sum of the discount for each order line',
        // },
        // {
        //     name:'order.orderExtraDiscount', // 订单额外折扣
        //     key:'extra_discount',
        //     type:'inputNumber', 
        //     disabled:true,
        //     prefix:true,
        //     hideButton:true,
        //     questionIcon:true,
        //     min:0,
        //     width:'420px',
        //     tips:'The sum of the extra discount for each order line',
        // },
        // {
        //     name:'order.orderTax', // 扣税金额
        //     key:'order_tax',
        //     type:'inputNumber', 
        //     disabled:true,
        //     prefix:true,
        //     hideButton:true,
        //     min:0,
        //     width:'420px',
        //     questionIcon:true,
        //     tips:'Order Tax = (Pay Amount / (1 + Tax Rate)) * Tax Rate',
        // },
        // {
        //     name:'order.payAmount', // 支付金额
        //     key:'pay_amount',
        //     type:'inputNumber',
        //     disabled:true,
        //     prefix:true,
        //     hideButton:true,
        //     questionIcon:true,
        //     error:false,
        //     helpMasg:'',
        //     validateStatus:'',
        //     min:0,
        //     width:'420px',
        //     tips:'Pay Amount = Order Amount - Order Discount - Extra Discount - Payment Discount + Cargo Freight',
        // },

        {
            name:'order.orderDiscount', // 订单折扣
            key:'order_discount',
            type:'input', 
            disabled:true,
            prefix:true,
            questionIcon:true,
            width:'420px',
            tips:'The sum of the discount for each order line',
        },
        {
            name:'order.orderExtraDiscount', // 订单额外折扣
            key:'extra_discount',
            type:'input', 
            disabled:true,
            prefix:true,
            questionIcon:true,
            width:'420px',
            tips:'The sum of the extra discount for each order line',
        },
        {
            name:'order.totalPaymentDiscount', // 总支付折扣
            key:'total_payment_discount',
            type:'input', 
            disabled:true,
            prefix:true,
            questionIcon:true,
            width:'420px',
            tips:'The sum of payment discount and payment discount 2',
        },
        {
            name:'order.totalFreight', // 总运费
            key:'total_freight',
            type:'input', 
            disabled:true,
            prefix:true,
            questionIcon:true,
            width:'420px',
            tips:'Sum of freight',
        },
        {
            name:'order.orderTax', // 扣税金额
            key:'order_tax',
            type:'input', 
            disabled:true,
            prefix:true,
            width:'420px',
            questionIcon:true,
            tips:'Order Tax = (Invoice Amount / (1 + Tax Rate)) * Tax Rate',
        },
        {
            name:'order.InvoiceAmount', // 支付金额
            key:'pay_amount',
            type:'input',
            disabled:true,
            prefix:true,
            questionIcon:true,
            error:false,
            helpMasg:'',
            validateStatus:'',
            width:'420px',
            tips:'Invoice Amount = Order Amount - Discount - Extra Discount - Total Payment Discount + Total Freight',
        },
        {
            name:'order.payWithin14daysDiscount', // 14天内付款时的支付金额
            key:'pay_with_days_discount',
            type:'input',
            disabled:true,
            prefix:true,
            questionIcon:true,
            width:'420px',
            tipToLocale:true,
            tips:'order.day14Tip',
        },
    ]
}

// 创建订单-客户信息
const CreateOrderForm3 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'190px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.customerName', // 客户名称
            key:'customer_entity_id',
            type:'select',   
            allowClear:true,
            required:true,
            addIcon:true,
            width:'420px',
            placeholder:'base.input',
            tips:'It is optional to input',
            options:[]
        },
        {
            name:'customer.defaultAddress', // 客户-发货地址
            key:'customer_id',
            type:'select',   
            allowClear:true,
            required:true,
            addIcon:false,
            width:'420px',
            placeholder:'base.input',
            tips:'It is optional to input',
            options:[]
        },
        {
            name:'customer.invoiceAddress', // 客户-发票地址
            key:'customer_invoice_id',
            type:'select',   
            allowClear:true,
            required:true,
            addIcon:false,
            width:'420px',
            placeholder:'base.input',
            tips:'It is optional to input',
            options:[]
        },
        {
            name:'customer.customerName2', // 客户名称2
            key:'name2',
            type:'input',
            disabled:true,
            width:'420px',
            placeholder:'',
        },
        {
            name:'order.customerEmail', // 客户邮箱
            key:'customer_email',
            type:'input',   
            allowClear:true,
            // required:true,
            disabled:true,
            questionIcon:true,
            width:'420px',
            placeholder:'',
            tips:'It is mandatory to order Hepha EBike or spare parts.',
        },
        {
            name:'order.customerType', // 客户类型
            key:'customer_type',
            type:'select',   
            allowClear:true,
            // required:true,
            disabled:true,
            questionIcon:true,
            width:'420px',
            placeholder:'',
            optionToLocale:true,
            tips:'Individual users or partern dealers',
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
        {
            name:'order.country', // 国家
            key:'country',
            type:'select',   
            allowClear:true,
            // required:true,
            disabled:true,
            width:'420px',
            marginLeft:'-30px',
            placeholder:'',
            options:[]
        },
        {
            name:'order.langTemplate', // 发票语言模板
            key:'file_lang_code',
            type:'select',   
            allowClear:true,
            // required:true,
            disabled:true,
            width:'420px',
            marginLeft:'-30px',
            placeholder:'',
            options:[
                {
                    label:'EN',
                    value:'EN',
                },
                {
                    label:'DE',
                    value:'DE',
                }
            ]
        },
        {
            name:'order.orderConfirmMail', // 订单确认邮箱
            key:'order_confirm_mail',
            type:'input',   
            allowClear:true,
            disabled:false,
            questionIcon:true,
            width:'420px',
            marginLeft:'-30px',
            tips:'The email address for receiving order confirmations.',
        },
    ]
}

// 创建订单- 新增客户基本信息
const AddCustomerBaseInfoForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'customer.customerType', // 客户类型
            key:'type',
            type:'select',   
            allowClear:true,
            disabled:true,
            width:'80%',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:2,
                    label:'order.ECommerceVendor',
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
        {
            name:'customer.contactName2', // 客户联系人名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.emailServiceFlag', // 是否提供邮箱
            key:'email_service_flag',
            type:'radio',   
            required:false,
            show:false,
            width:'80%',
            radioData:[
                {
                    label:'base.YES',
                    value:'YES',
                },
                {
                    label:'base.NO',
                    value:'NO',
                }
            ]
        },
        {
            name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        }
    ]
}

// 创建订单-新增客户地址
const AddCustomerAddressInfoForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'customer.addressType', // 地址类型
            key:'address_type', 
            type:'select',
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
            optionToLocale:true,
            options:[
                {
                    label:'customer.defaultAddress',
                    value:0,
                },
                {
                    label:'customer.invoiceAddress',
                    value:1
                },
                {
                    label:'customer.companyAddress',
                    value:2,
                    disabled:true
                }
            ]
        },
        {
            name:'customer.contactName', // 客户名称/收货人名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.contactName2', // 客户名称2
            key:'name2',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerPhone', // 客户电话
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        },
        {
            name:'customer.customerState', // 客户所在州
            key:'state',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCity', // 客户所在城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.street', // 客户所在街道
            key:'street',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        
        {
            name:'dealer.houseNumber', // 客户所在门牌号
            key:'house_number',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerAddr', // 客户地址
            key:'address', 
            type:'input',   
            allowClear:true,
            // required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
    ]
}

// 创建订单-新增客户发票地址
const AddInvoiceAddressForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'customer.addressType', // 地址类型
            key:'address_type', 
            type:'select',
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
            optionToLocale:true,
            options:[
                {
                    label:'customer.defaultAddress',
                    value:0,
                },
                {
                    label:'customer.invoiceAddress',
                    value:1
                },
                {
                    label:'customer.companyAddress',
                    value:2,
                }
            ]
        },
        {
            name:'customer.contactName', // 客户名称/收货人名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.contactName2', // 客户名称2
            key:'name2',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerPhone', // 客户电话
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        },
        {
            name:'customer.customerState', // 客户所在州
            key:'state',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCity', // 客户所在城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.street', // 客户所在街道
            key:'street',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.houseNumber', // 客户所在门牌号
            key:'house_number',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerAddr', // 客户地址
            key:'address', 
            type:'input',   
            allowClear:true,
            // required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
    ]
}


// 退换货记录-退货记录搜索
const ReturnQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'100px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.backNumber', // mes退货单号
            key:'back_number',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'base.input',
        },
        // {
        //     name:'returnExchange.sku', // sku
        //     key:'sku',
        //     type:'input',   
        //     allowClear:true,
        //     width:'200px',
        //     placeholder:'base.input',
        //     options:[]
        // },
        {
            name:'returnExchange.status', // 状态
            key:'status',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'returnExchange.initial',
                    value:0,
                },
                {
                    label:'returnExchange.returning',
                    value:1,
                },
                {
                    label:'returnExchange.exchangeProgress',
                    value:2,
                },
                {
                    label:'returnExchange.returnSuccessful',
                    value:3,
                },
                {
                    label:'returnExchange.exchangeSuccessful',
                    value:4,
                },
            ]
        },
        // {
        //     name:'returnExchange.source', // 来源
        //     key:'source',
        //     type:'select',   
        //     allowClear:true,
        //     width:'200px',
        //     placeholder:'base.select',
        //     options:[]
        // },
        {
            name:'returnExchange.backReasonType', // 退换货原因类型
            key:'back_reason_type',
            type:'select',   
            allowClear:true,
            width:'400px',
            placeholder:'base.select',
            options:[]
        },
        
    ]
}

// 退换货记录-换货记录搜索
const ExchangeQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'100px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.swapNumber', // mes换货单号
            key:'swap_number',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'base.input',
        },
        // {
        //     name:'returnExchange.swapInventoryCode', // 换货物料编码
        //     key:'swap_inventory_code', 
        //     type:'input',   
        //     allowClear:true,
        //     width:'200px',
        //     placeholder:'base.input',
        // },
        // {
        //     name:'returnExchange.sku', // sku
        //     key:'sku',
        //     type:'input',   
        //     allowClear:true,
        //     width:'200px',
        //     placeholder:'base.input',
        //     options:[]
        // },
        {
            name:'returnExchange.status', // 状态
            key:'status',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'returnExchange.initial',
                    value:0,
                },
                {
                    label:'returnExchange.returning',
                    value:1,
                },
                {
                    label:'returnExchange.exchangeProgress',
                    value:2,
                },
                {
                    label:'returnExchange.returnSuccessful',
                    value:3,
                },
                {
                    label:'returnExchange.exchangeSuccessful',
                    value:4,
                },
            ]
        },
        // {
        //     name:'returnExchange.source', // 来源
        //     key:'source',
        //     type:'select',   
        //     allowClear:true,
        //     width:'200px',
        //     placeholder:'base.select',
        //     options:[]
        // },
        {
            name:'returnExchange.backReasonType', // 退换货原因类型
            key:'back_reason_type',
            type:'select',   
            allowClear:true,
            width:'400px',
            placeholder:'base.select',
            options:[]
        },
        
    ]
}

// 退换货-基础信息
const CreateReturnExchangeForm1 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.type', //类型
            key:'type',
            type:'select',  
            required:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'returnExchange.return',
                    value:1,
                },
                {
                    label:'returnExchange.exchange',
                    value:2,
                }
            ]
        },
        {
            name:'returnExchange.status', // 状态
            key:'status',
            type:'select',   
            // allowClear:true,
            disabled:true,
            required:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                // {
                //     label:'returnExchange.initial',
                //     value:0,
                // },
                {
                    label:'returnExchange.returning',
                    value:1,
                },
                {
                    label:'returnExchange.exchangeProgress',
                    value:2,  // 先不要动
                },
                // {
                //     label:'returnExchange.returnSuccessful',
                //     value:3,
                // },
                // {
                //     label:'returnExchange.exchangeSuccessful',
                //     value:4,
                // },
            ]
        },
        {
            name:'returnExchange.source', // 来源
            key:'source',
            type:'input',   
            disabled:true,
            width:'420px',
        },
        {
            name:'returnExchange.discount', // 折扣
            key:'discount',
            type:'inputNumber',   
            allowClear:true,
            hideButton:true,
            prefix:true,
            disabled:false,
            width:'420px',
            min:0,
        },
    ]
}

// 退换货-退货信息
const CreateReturnExchangeForm2 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.backReasonType', // 退换货原因类型
            key:'back_reason_type', 
            type:'select',
            required:true,
            width:'420px',
            placeholder:'base.select',
        },
        {
            name:'returnExchange.backReason', // 退换货原因
            key:'back_reason',
            type:'textarea',   
            allowClear:true,
            required:true,
            showWordLimit:true,
            maxLength:150,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'returnExchange.backTimestamp', // 退货时间
            key:'back_timestamp',
            type:'date',   
            allowClear:true,
            required:true,
            show:true,
            width:'420px',
        },
        {
            name:'order.rollOverInventory', // 退货仓库
            key:'back_factory',
            type:'select',
            allowClear:true,
            required:true,
            show:true,
            width:'420px',
            placeholder:'base.select',
            options:[
                {
                    label:'Maisach',
                    value:'Maisach',
                },
                {
                    label:'ZU',
                    value:'ZU',
                },
                {
                    label:'CWH',
                    value:'CWH',
                },
            ]
        },
        {
            name:'returnExchange.courierType', // 退货物流公司
            key:'courier_type',
            type:'select',   
            allowClear:true,
            required:true,
            // disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.courierNo', // 退货物流单号
            key:'courier_no',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'returnExchange.ibsVerificationType', // IBS验证方案类型
            key:'ibs_verification_type',
            type:'select',
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.ibsVerificationPlan', // IBS验证方案描述
            key:'ibs_verification_plan', 
            type:'textarea',   
            allowClear:true,
            showWordLimit:true,
            maxLength:250,
            width:'420px',
            placeholder:'base.input',
        },
        // {
        //     name:'order.instruction', // 备注
        //     key:'instruction', 
        //     type:'textarea',   
        //     allowClear:true,
        //     showWordLimit:true,
        //     maxLength:150,
        //     width:'420px',
        //     placeholder:'base.input',
        // },
    ]
}

// 退换货-换货信息
const CreateReturnExchangeForm3 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.swapTimestampPlan', // 换货计划发出时间（换货需要填）
            key:'swap_timestamp_plan',
            type:'date',   
            allowClear:true,
            required:true,
            width:'420px',
        },
        {
            name:'returnExchange.swapCourierType', // 换货物流公司
            key:'swap_courier_type',
            type:'select',   
            allowClear:true,
            // required:true,
            // disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.swapCourierNo', // 换货物流单号
            key:'swap_courier_no',
            type:'input',   
            allowClear:true,
            disabled:true,
            // required:true,
            width:'420px',
            placeholder:'base.input',
        },
    ]
}

// 订单退款
const RefundForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.orderName', //订单名称
            key:'order_name',
            type:'input',  
            hideButton:true,
            prefix:true,
            disabled:true,
            width:'420px',
        },
        {
            name:'order.amount', // 订单金额
            key:'order_amount',
            type:'inputNumber', 
            hideButton:true,
            prefix:true,
            disabled:true,
            width:'420px',
        },
        {
            name:'order.payAmount2', // 支付金额
            key:'pay_amount',
            type:'inputNumber',   
            hideButton:true,
            prefix:true,
            disabled:true,
            width:'420px',
        },
        {
            name:'order.refundAmount', // 退款金额
            key:'refund_amount',
            type:'inputNumber',   
            allowClear:true,
            hideButton:true,
            prefix:true,
            disabled:false,
            required:true,
            width:'420px',
            min:0,
            helpMasg:'',
            error:false,
        },
        {
            name:'order.currentAmount', // 当前订单金额
            key:'current_amount',
            type:'inputNumber',   
            allowClear:true,
            hideButton:true,
            prefix:true,
            disabled:true,
            questionIcon:true,
            width:'420px',
            min:0,
            tips:'Current Amount = Pay Amount - Refund Amount',
        },
        {
            name:'order.refundTimestamp', // 退款日期
            key:'refund_date',
            type:'date',   
            allowClear:true,
            required:true,
            width:'420px',
        },
        {
            name:'order.refundReasonType', // 退款原因类型
            key:'reason_type',
            type:'select',   
            allowClear:true,
            width:'420px',
            options:[]
        },
        {
            name:'order.refundReason', // 退款原因
            key:'reason',
            type:'textarea',   
            allowClear:true,
            width:'420px',
            showWordLimit:true,
            maxLength:150,
        },
    ]
}

OrderListQuery.formField.forEach(item=>{
    OrderListQuery.formData[item.key] = ''
})

DeliverForm.formField.forEach(item=>{
    DeliverForm.formData[item.key] = ''
})

CreateOrderForm3.formField.forEach(item=>{
    CreateOrderForm3.formData[item.key] = ''
})

CreateOrderForm2.formField.forEach(item=>{
    CreateOrderForm2.formData[item.key] = ''
})

CreateOrderForm1.formField.forEach(item=>{
    CreateOrderForm1.formData[item.key] = ''
})

AddCustomerBaseInfoForm.formField.forEach(item=>{
    AddCustomerBaseInfoForm.formData[item.key] = ''
})
AddCustomerAddressInfoForm.formField.forEach(item=>{
    AddCustomerAddressInfoForm.formData[item.key] = ''
})
AddInvoiceAddressForm.formField.forEach(item=>{
    AddInvoiceAddressForm.formData[item.key] = ''
})

ReturnQueryForm.formField.forEach(item=>{
    ReturnQueryForm.formData[item.key] = ''
})

ExchangeQueryForm.formField.forEach(item=>{
    ExchangeQueryForm.formData[item.key] = ''
})

CreateReturnExchangeForm1.formField.forEach(item=>{
    CreateReturnExchangeForm1.formData[item.key] = ''
})

CreateReturnExchangeForm2.formField.forEach(item=>{
    CreateReturnExchangeForm2.formData[item.key] = ''
})

CreateReturnExchangeForm3.formField.forEach(item=>{
    CreateReturnExchangeForm3.formData[item.key] = ''
})

RefundForm.formField.forEach(item=>{
    RefundForm.formData[item.key] = ''
})

export {
    OrderListQuery,
    DeliverForm,

    CreateOrderForm1,
    CreateOrderForm2,
    CreateOrderForm3,

    AddCustomerBaseInfoForm,
    AddCustomerAddressInfoForm,
    AddInvoiceAddressForm,

    ReturnQueryForm,
    ExchangeQueryForm,
    CreateReturnExchangeForm1,
    CreateReturnExchangeForm2,
    CreateReturnExchangeForm3,

    RefundForm,
}